import { useDroppable } from '@dnd-kit/core';
import { Close, DragIndicator } from '@mui/icons-material';
import { Box, IconButton, alpha } from '@mui/material';
import React from 'react';
import ClassroomStudent from '../classroom-student/ClassroomStudent';
import DraggableClassroomStudent from '../draggable-classroom-student/DraggableClassroomStudent';
import StudentDropzone from '../student-dropzone/StudentDropzone';
import { ClassroomStudentStatus, ClassroomStudent as IClassroomStudent } from '../types';

export interface DroppableClassroomStudentProps {
  positionId: string;
  onAssign: (userId?: string) => void;
  assignedStudent?: IClassroomStudent;
}

/**
 * A student can be dropped onto another student or on a dropdown.
 * So we need to wrap all components with one "droppable" container.
 */
const DroppableClassroomStudent = ({ assignedStudent, onAssign, positionId }: DroppableClassroomStudentProps) => {
  const { active, isOver, setNodeRef } = useDroppable({ id: positionId });

  return (
    <Box ref={setNodeRef}>
      <StudentDropzone isOver={isOver} />
      {assignedStudent && (
        <DraggableClassroomStudent
          id={assignedStudent.id}
          isOver={isOver && active?.id !== positionId}
          style={{ position: 'absolute', top: 0, width: '100%' }}
        >
          <ClassroomStudent {...assignedStudent} joined={assignedStudent.status === ClassroomStudentStatus.Joined}>
            <IconButton onClick={() => onAssign(undefined)} size="small">
              <Close />
            </IconButton>
            <DragIndicator sx={theme => ({ color: alpha(theme.palette.text.primary, 0.3) })} />
          </ClassroomStudent>
        </DraggableClassroomStudent>
      )}
    </Box>
  );
};

export default DroppableClassroomStudent;
